import React, { forwardRef, ReactNode, Ref, useImperativeHandle } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { StyledMenu } from "./StyledMenu";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      float: "right",
    },
    ".MuiListItemIcon-root": {
      minWidth: "20px",
    },
  }),
);

interface CustomMenuProps {
  alternativeButtonIcon?: ReactNode;
  children?: ReactNode;
  disabled?: boolean;
}

function CustomMenu(props: CustomMenuProps, ref: Ref<{ close: () => void }> | undefined) {
  const { alternativeButtonIcon, children, disabled } = props;
  const classes = useStyles(props);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useImperativeHandle(ref, () => ({
    close: (): void => {
      handleClose();
    },
  }));

  if (disabled) {
    return <IconButton disabled>{alternativeButtonIcon || <MoreVertIcon />}</IconButton>;
  }

  return (
    <div className={classes.root}>
      <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
        {alternativeButtonIcon || <MoreVertIcon />}
      </IconButton>
      <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {children}
      </StyledMenu>
    </div>
  );
}

export default forwardRef(CustomMenu);
